import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Upload, Loader2 } from 'lucide-react';
import { API } from './api';

// Upload a bureau "results of your dispute" letter; AI reads it and logs each account's result.
export default function ResponseUpload({ onDone }) {
  const [busy, setBusy] = useState(false);
  const [client, setClient] = useState('');
  const [res, setRes] = useState(null);
  const send = async (file) => {
    if (!file) return;
    setBusy(true); setRes(null);
    const fd = new FormData(); fd.append('file', file); fd.append('client_name', client);
    try {
      const r = await axios.post(`${API}/responses`, fd);
      setRes(r.data); onDone?.();
      toast.success(`Logged ${r.data.matched.length} result${r.data.matched.length === 1 ? '' : 's'}`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not read that letter'); }
    setBusy(false);
  };
  return (
    <div className="rounded-xl border border-sky-500/30 bg-zinc-900/70 p-3 space-y-2" data-testid="response-upload">
      <p className="text-sm font-bold text-white">Upload a bureau response letter</p>
      <p className="text-[11px] text-zinc-500">PDF or photo. AI reads which accounts were deleted, updated or verified and logs them on the matching letters.</p>
      <div className="flex flex-wrap gap-2">
        <input value={client} onChange={(e) => setClient(e.target.value)} placeholder="Client name (optional, helps matching)" data-testid="response-client"
          className="min-w-0 flex-1 rounded-md border border-zinc-700 bg-zinc-950 px-2 py-1.5 text-xs text-white" />
        <label className={`inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-sky-500 px-3 py-1.5 text-xs font-bold text-black hover:bg-sky-400 ${busy ? 'opacity-60 pointer-events-none' : ''}`} data-testid="response-upload-btn">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}{busy ? 'Reading…' : 'Choose file'}
          <input type="file" accept="application/pdf,image/*" className="hidden" data-testid="response-file" onChange={(e) => { send(e.target.files?.[0]); e.target.value = ''; }} />
        </label>
      </div>
      {res && (
        <div className="text-[11px] space-y-0.5" data-testid="response-result">
          <p className="text-zinc-300">{res.bureau?.toUpperCase()} · {res.consumer_name || 'unknown name'}</p>
          {res.matched.map((m) => <p key={m.record_id} className="text-emerald-300">✓ {m.account} → {m.outcome.replace('_', ' ')}</p>)}
          {res.unmatched.map((u, i) => <p key={i} className="text-amber-300">• {u.creditor}: {u.outcome} (no matching letter found — log it by hand below)</p>)}
        </div>
      )}
    </div>
  );
}
